var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInfoCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Huge-icon/interface/solid/information-circle"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Subtract",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.99992 15.1663C11.6818 15.1663 14.6666 12.1816 14.6666 8.49967C14.6666 4.81778 11.6818 1.83301 7.99992 1.83301C4.31802 1.83301 1.33325 4.81778 1.33325 8.49967C1.33325 12.1816 4.31802 15.1663 7.99992 15.1663ZM8.49992 5.83301C8.49992 5.55687 8.27606 5.33301 7.99992 5.33301C7.72378 5.33301 7.49992 5.55687 7.49992 5.83301V6.49967C7.49992 6.77582 7.72378 6.99967 7.99992 6.99967C8.27606 6.99967 8.49992 6.77582 8.49992 6.49967V5.83301ZM8.49992 8.16634C8.49992 7.8902 8.27606 7.66634 7.99992 7.66634C7.72378 7.66634 7.49992 7.8902 7.49992 8.16634V11.1663C7.49992 11.4425 7.72378 11.6663 7.99992 11.6663C8.27606 11.6663 8.49992 11.4425 8.49992 11.1663V8.16634Z",
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoCircle);
export default __webpack_public_path__ + "static/media/info-circle.9c7f3177d55109a4c0ae2757d916f098.svg";
export { ForwardRef as ReactComponent };